import { render } from "./DomainsDonutChart.vue?vue&type=template&id=24966b0f&scoped=true"
import script from "./DomainsDonutChart.vue?vue&type=script&lang=js"
export * from "./DomainsDonutChart.vue?vue&type=script&lang=js"

import "./DomainsDonutChart.vue?vue&type=style&index=0&id=24966b0f&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24966b0f"]])

export default __exports__